import * as React from 'react';

import ErrorIcon from '@material-ui/icons/Error';
import styles from './Stylesheet.module.css';

const ErrorMessageBanner = ({text, msgStyle={}}) => {

  const defaultStyle = {
    margin: '0 0 1rem',
  };

  const wrapperStyle = Object.assign(defaultStyle, msgStyle);

  return (
    <div className={`${styles.errorMessage} ${styles.errorMessageBanner}`} style={wrapperStyle}>
      <ErrorIcon />
      {text}
    </div>  
  )
}

export default ErrorMessageBanner;